import { useCallback, useSyncExternalStore } from 'react';
export function useMediaQuery(query) {
    const subscribe = useCallback((listener) => {
        const mql = window.matchMedia(query);
        const abortController = new AbortController();
        mql.addEventListener('change', listener, {
            signal: abortController.signal,
        });
        return () => {
            abortController.abort();
        };
    }, [query]);
    const getSnapShot = useCallback(() => window.matchMedia(query).matches, [query]);
    const getServerSnapShot = () => true;
    return useSyncExternalStore(subscribe, getSnapShot, getServerSnapShot);
}
//# sourceMappingURL=useMediaQuery.js.map